import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import type { ReactElement } from "react";

type ChildrenType = {
  children: React.ReactElement;
};

const AuthRoute = ({ children }: ChildrenType): ReactElement => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn() ? children : <Navigate to="/authprompt" replace />;
};

export default AuthRoute;
